export default __webpack_public_path__ + "31d758425d6cbbcc6d0cf2b6653f433b.png";